export { default } from "./ComparisonShoppingSection";
